module.exports = __webpack_public_path__ + "static/media/avatar_40.46e78cc1.svg";